<template>
  <div>
    <div
        class="col-md-9 pl-0 mt-3 centre_sm_none"
        :class="{'d-sm-block':!specail&&(viewToggle||clickToggle),'col-md-99': !specail}"
    >
      <div class="scroll-wrap">
        <ul class="scroll-text" id="scrollText">
          <li class="scroll-li" v-for="(item, index) in itemDetailValue.content.slice(0, 10)" :key="index" @click="gotoSearchDetail(item)">{{ item.sourceAsMap.title }}</li>
          <li class="scroll-li" v-for="(item, index) in itemDetailValue.content.slice(0, 3)" :key="index + 10" @click="gotoSearchDetail(item)">{{ item.sourceAsMap.title }}</li>
        </ul>
        <ul class="scroll-shadow" id="scrollShadow" style="position: absolute; z-index: -999; top: -9999px">;
          <li class="scroll-li" v-for="(item, index) in itemDetailValue.content.slice(0, 10)" :key="index">{{ item.sourceAsMap.title }}</li>
          <li style="clear: both"></li>
        </ul> 
      </div>
      <div v-show="!articleShow" class="inner-container">
        <!-- <div class="info-btns">
          <a href="#/Finance/Xinhua500Index">
            <el-button type="primary">Xin Hua 500</el-button>
          </a>
          <a href="#/Finance/IronOreIdxPrice" style="margin-left: 10px;">
            <el-button type="primary">Xinhua iron ore price index</el-button>
          </a>
          <a href="#/bond/base_info" style="margin-left: 10px;">
            <el-button type="primary">Bond</el-button>
          </a>
        </div> -->
        <div class="tabs-container">
          <el-tabs type="card" v-model="editableTabsValue" tab-position="top" @tab-click="handleClick" style="height: 60vh">
            <el-tab-pane label="Xin Hua 500" name="Xin Hua 500">
              <span slot="label" @mouseover="mouseoverTab('Xin Hua 500')">Xinhua 500 Index</span>
              <template>
                <div class="component-charts" style="height: 56vh;margin-left: 10px;overflow-y: auto;background: #fff;">
                  <handicap :code="code" :throttle="throttle"></handicap>
                  <div class="component-chart" id="component-chart">
                    <quote-graph :throttle="throttle" :code="code"></quote-graph>
                  </div>
                </div>
              </template>
            </el-tab-pane>
            <!-- <el-tab-pane label="Xinhua iron ore price index" name="Xinhua iron ore price index"  :lazy="true">
              <span slot="label" @mouseover="mouseoverTab('Xinhua iron ore price index')">Xinhua-China Iron Ore Price Index</span>
              <template>
                <iron-ore-idx-price :isok="true" style="height: 54vh;width: calc(100% - 0px);background: #fff;"></iron-ore-idx-price>
              </template>
            </el-tab-pane> -->
            <el-tab-pane label="Bond" name="Bond">
              <span slot="label" @mouseover="mouseoverTab('Bond')">Bond</span>
              <template>
                <div style="height: 55vh; background-color: #fff; margin-left: 10px;">
                  <el-row class="bb bgw" align="center" style="height:60px;line-height:60px;padding:0 10px;">
                    <el-col :span="12">
                      <span class="stockName">{{ stockName }}</span>
                      <span class="stockCode">{{ stockCode }}</span>
                      <span class="stockNowpage">{{ pageName}}</span>
                      <!-- <i class="el-icon-view"></i> -->
                    </el-col>
                    <el-col :span="4">
                      <!-- <span class="stockNowpage">Switch bonds</span> -->
                    </el-col>
                    <el-col :span="6">
                      <!-- <el-input placeholder="Please enter content" v-model="stockinp">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                      </el-input> -->
                    </el-col>
                    <el-col :span="2" style="text-align:center;">
                      <!-- <span class="icon"></span>
                      <span class="text" @click="exportExcel">export Excel</span> -->
                    </el-col>
                  </el-row>
                  <base-info></base-info>
                </div>
              </template>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="report-container" style="height: 360px; margin-top:3vh;display: flex; justify-content: space-between">
          <div class="report-item">
            <a href="/#/report/5019/issue/6878">
              <div class="repo-title">
                <span class="overflow-hidden-1">Who dominates the world's auto industry?</span>
                <span class="link-out"></span>
              </div>
              <div class="repo-img">
                <img src="/db/static/images/repo-1.png" alt="">
              </div>
            </a>
          </div>
          <div class="report-item">
            <a href="/#/report/5019/issue/7064">
              <div class="repo-title ">
                <span class="overflow-hidden-1">Report on China's Free Trade Agreements with Foreign Partners</span>
                <span class="link-out"></span>
              </div>
              <div class="repo-img">
                <img src="/db/static/images/repo-3.png" alt="">
              </div>
            </a>
          </div>
          <div class="report-item">
            <a href="/#/report/5019/issue/6881">
              <div class="repo-title">
                <span class="overflow-hidden-1">The Impact of Internet on Strategy: How Digital Tactics Fit in the Marketing for Chinese Auto Industry</span>
                <span class="link-out"></span>
              </div>
              <div class="repo-img">
                <img src="/db/static/images/repo-2.png" alt="">
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="centre_content nano" id="centre_contents" v-show="articleShow">
        <span class="nano-content p-4" id="spanblock" style="padding-bottom: 100px!important;">
          <p class="text-center" v-if="articleLoadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
          <p>
            <span class="back-button" @click="articleShow = false"> < Back</span>
          </p>
					<h1 class="information_article_headline" style="text-align: center">{{ articleDetails.title }}</h1>
          <p class="information_article_info" v-if="!articleDetails.space">
            <span class="mr-2">{{ articleDetails.published }}</span>
            <span v-if="articleDetails.author && articleDetails.author.length > 0">Author：
              <span class="mr-2" v-for="value in articleDetails.author">{{value}}</span>
            </span>
            <span v-if="articleDetails.source">Sources：{{articleDetails.source}}</span>
          </p>
					<div class="information_article_abstract rounded" v-if="articleDetails.description">
						<p>
							Abstract：{{articleDetails.description }}
						</p>
					</div>
          <!-- 文章 -->
			    <div class="information_article_details text-indent2" v-html="articleDetails.content"></div>
          <!-- 组图 -->
          <div class="information_article_details text-indent2" v-if="articleDetails.appid === 2">
            <div v-for="item in JSON.parse(articleDetails.content)">
              <p>
                <img class="img-thumbnail" :src="item.url"/>
              </p>
              <p v-html="item.description"></p>
            </div>
          </div>
			    <span class="f12 d-block mb-2" v-if="articleDetails.editor">Editor：{{ articleDetails.editor }}</span>
          <div class="pb-4 w-100 border-top-0 border-right-0 border-left-0" style="border: 1px dashed rgba(232,234,239,1);">
            <span class="float-left f12 text-black-50" v-if="articleDetails.keyword && articleDetails.keyword.length > 0">Keywords：</span>
            <span v-for="value in articleDetails.keyword" class="float-left f12 text-black-50 pl-2 pr-2">
              <a @click="xhJumpPDSearchType(value)" class="antistop">{{ value }}</a>
              <!--<a :href="'/tags/'+ value" class="antistop" target="_blank">{{value}}</a>-->
            </span>
          </div>
          <div v-if="articleDetails.attachment&&articleDetails.attachment.length>0">
            <a :href="item.url" target="_blank" v-for="(item,index) in articleDetails.attachment" :key="index"
               style="color: #0a75be!important">{{ item.alias }}</a>
          </div>
			  </span>
      </div>
    </div>
    <div
        class="col-md-3 mt-3 centre_sm_none" style="padding: 0; background-color: #fff;"
        :class="{'d-sm-block':!specail&&(viewToggle||!clickToggle),'d-none':!specail}">
        <el-tabs v-model="activeName" @tab-click="handleClickInfo">
          <el-tab-pane label="Information" name="first"></el-tab-pane>
          <el-tab-pane label="Financial Str. Release" name="second"></el-tab-pane>
        </el-tabs>
      <!-- <p class="title" style="cursor: pointer;" @click="()=>{this.specail = false;}">Information</p> -->
      <div  class="search-detail max-width-sm" @mouseenter="()=>{mouseoverFalg=true}" @mouseleave="()=>{mouseoverFalg=false}" v-loading="loading"  style="height:78vh;">
        <item-list id='article_right_list' class="search-item" :value="itemDetailValue"  :resultValue="resultValue"
                     @gotoDetail="gotoSearchDetail" @jumpList="scrollHandler" @searchItem="changeCommon"
        ></item-list>
      </div>
      <div v-show="mouseoverFalg" @mouseenter="()=>{mouseoverFalg=true}" style="cursor: pointer;position: absolute;top: 47px;left: 0;width: 30px;background: linear-gradient(to left, rgb(246 246 246 / 10%) 0%, #e8eaec 53%, #c0c4cc 100%);height: 100%;display: flex;align-items: center;justify-content: center;" @click="()=>{this.specail = false;}">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="" style="width:30px;position: fixed;cursor: pointer;top: 76px;right: 2px;height: 100%;z-index: 6;padding: 0; background: linear-gradient(to right, #fff 0%, rgb(232, 234, 236) 53%, rgb(192, 196, 204) 100%);" :class="{'d-sm-block':!specail&&(viewToggle||!clickToggle),'d-none':specail}" @click="()=>{this.specail = true;}">
      <p style="font-size: 16px;line-height: 2;color: #409cf9; margin: 10px 0 10px 0;padding-left: 0px;font-weight: 500;position: relative;writing-mode: vertical-lr;">{{activeName=='first'?'Information':'Financial Str. Release'}}</p>
      <div style="width: 100%;height: 60%;display: flex;justify-content: center;align-items: center;"><i class="el-icon-arrow-left"></i></div>
    </div>
  </div>
</template>
<script>
// 打包前
import x from './packages/build.js'
const { quoteGraph,handicap } = x
import IronOreIdxPrice from "./components/ArticleDetails/IronOreIdxPrice";
import baseInfo from "./bond/base_info";
import itemList from './components/ArticleDetails/ItemList.vue'
import searchMap from '../search/utils/searchMap'
import { getQueryString } from "./utils/assist";
import { cnfsimplekw,cnfrecommend } from '@/common/js/http/v3Api'
import { baseUrl } from '@/common/js/http/pdBase'
export default ({
  name: 'ChinaInformationV2',
  components: {
    IronOreIdxPrice,
    itemList,
    handicap,
    quoteGraph,
    baseInfo,
  },
  data() {
    return {
      activeName: 'first',
      mouseoverFalg: false,
      editableTabsValue: "Xin Hua 500",
      activeIndex: '',
      isMobilePhone: false,
      stockinp: '',
      pageName: '',
      stockCode: '120303.SH',
      stockName: '03Three Gorges debt',
      code: "989001.CNI",
      throttle: 3000,
      tableData: [],
      startnum: 0,
      length: '30',
      isLoad: true,
      loadShow: true,
      nations: [],
      classifys: [],
      industrys: [],
      homeLists: [],
      probations: [], //试读
      industryTexts: [],
      classifysTexts: [],
      nationsTexts: [],
      nationsSelected: 'Global',
      classifysSelected: 'All news',
      industrysSelected: 'All industries',
      industryID: '0', //分类ID
      page: 0,
      specail: false, //特殊处理 小于544px
      total_page: 1,
      probationes: [],
      firstlist: '',
      token: '',
      viewToggle: true,
      clickToggle: true,
      endShow: false,
      getissues: [],
      getzines: [],
      years: [],
      selectedKey: '',
      id: '5008',
      year: '',
      detailes: {},
      articleShow: false,
      articleLoadShow: false,
      articleDetails: {},
      itemDetailValue: {
        page: 1,
        size: 20,
        pageCount: 0,
        isDetail: true,
        spaceEndShow: false,
        spaceLoadShow: false,
        content: []
      },
      keyWord: this.$route.params.keyword || 'Financial Str. Release',
      resultValue: {
        keyWord: '',
        result: '',
        rsCount: 10
      },
      loading: false,
      allTabData: {
        title: '',
        tabArr: []
      },
      selectType: this.$route.params.type || 'All',
      sortField: 'published',
      newrecoToken: '',
    }
  },
  created: function() {
    this.getcode();
    var self = this;
    let that = this;
    if (this.IsPC() && (document.body.clientWidth >= 1400)) {
      this.specail = true
    } else {
      this.specail = false
    }
    this.viewToggle = this.IsPC();

    /* 报告接口 */
    this.$axios.post('/api/pc/getzine', {
      id: self.id
    }).then(data => {
      var getzines = data.data.data;
      self.getzines = getzines;
    })
    this.$axios.post('/api/pc/getreportcountryyear', {
      id: self.id
    }).then(data => {
      if (data.data.state) {
        $.each(data.data.data, function(index, value) {
          if (self.years.indexOf(value.year) === '-1') {
            self.years.push(value.year);
          }
        })
        self.year = self.years[0]
      }
    })
    this.getCountryReport()
  },
  mounted() {
    this.$nextTick(()=>{
      this.getFtzNew(1)
      // this.requestAllData(1)
    })
    setTimeout(() => this.rollMove(1), 1000);
  },
  methods: {
    handleClickInfo(val) {
      if (this.activeName=='first'){
        this.getFtzNew(1)
      } else {
        this.requestAllData(1)
      }
    },
    mouseoverTab(name) {
      this.editableTabsValue = name;
    },
    handleClick(targetName) {
      if (targetName.name == "Xin Hua 500") {
        this.$router.push('/Finance/Xinhua500Index')
      }
      if (targetName.name == "Xinhua iron ore price index") {
        this.$router.push('/Finance/IronOreIdxPrice')
      }
      if (targetName.name == "Bond") {
        this.$router.push('/bond/base_info?stockCode=120303.SH')
      }
    },
    // 提示条滚动效果
    rollMove(speed) {
      setTimeout(() => {
        let width = document.getElementById('scrollShadow').getBoundingClientRect().width;
        let scrollBox = document.getElementById('scrollText');
        let distance = 0;
        setInterval(() => {
          distance = distance - speed;
          if(-distance >= width) {
            distance = 0;
          }
          scrollBox.style.transform = 'translateX('+ distance + 'px)';
        }, 20);
      }, 800);
    },
    getcode() {
      let newCode = getQueryString("code");
      if (newCode) {
        this.code = newCode;
      }
    },
    //返回数据公共处理部分
    dataPublic(len) {
      this.startnum += len;
    },
    gotoSearchDetail(data) {
      this.showArticle(data.sourceAsMap.contentid?data.sourceAsMap.contentid: data.sourceAsMap.resourceId);
    },
    changeCommon(val) { // 点击右侧卡片重新搜索
      let route = {
        path: '',
        params: {
          type: this.selectType,
          keyword: encodeURIComponent(val.name)
        }
      }
      route.path = `${this.createdPath()}/${route.params.type}/${true}/${route.params.keyword}`
      this.$router.push(route)
    },
    sortList(val) { // 排序
      this.sortField = val
      this.sorts = '1'
      // this.requestAllData(true)
    },
    search(val) { // 搜索结果 仍然搜索触发
      const params = { ...this.$route.params }
      params.isRecovery = 0
      this.$router.replace({ params })
    },
    showArticle: function(contentid) {
      const pos = contentid.indexOf('_');
      const ctnId= contentid.substring(pos+1);
      this.articleLoadShow = true;
      if (!this.articleShow) {
        this.articleShow = true;
      }
      this.$axios.post('/api/pc/getarticledetail', {
        id: ctnId
      }).then(response => {
        this.articleLoadShow = false;
        if (response.data.state) {
          this.articleDetails = response.data.data;
        } else {
          this.clickToggle = false
          $('.wrap').text(response.data.error)
          $('.wrap').show().delay(1500).hide(100)
        }
      })
    },
    goback() {
      if (this.viewToggle) {
        this.$router.push({ name: 'consult_particulars_organization', params: { id: "10", type: 1 } })
      } else {
        this.clickToggle = true;
      }
    },
    clickToggles() {
      this.clickToggle = false;
    },
    scrollHandler(flag, num) {
      this.page = this.itemDetailValue.page
      if (this.activeName=='first'){
        // localStorage.removeItem("selectValueDetail")
        // localStorage.removeItem("itemDetailValueList")
        // localStorage.removeItem("resultValueList")
        // localStorage.removeItem("selectValueList")
        // localStorage.removeItem("selectValueDetail")
        this.getFtzNew(this.page)
      } else {
        this.requestAllData(this.page)
        // localStorage.removeItem("newValueDetail")
        // localStorage.removeItem("newitemDetailValueList")
        // localStorage.removeItem("newValueDetail")
  
      }
    },
    getCountryReport() {
      this.$axios.post('/api/pc/getreportcountry', {
        id: this.id,
        year: this.year,
        country: this.searchName
      }).then(data => {
        if (data.data.state) {
          this.getissues = data.data.data;
          if (this.getissues) {
            this.selectedKey = Object.keys(this.getissues)[0];
          }
        }

      })
    },
    getIssueDetail: function(eid) {
      this.eid = eid;
      let that = this;
      this.clickToggle = false;
      that.pdfdetail = '';
      this.$axios.post('/api/pc/getissuedetail', { id: eid }).then(data => {
        this.clickToggle = false;
        that.detailes = data.data.data;
        this.$nextTick(function() {
          this.load();
        })
        this.articleShow = false
      })
    },
    getZine: function() {
      this.$axios.post('/api/pc/getzine', { id: this.id }).then(data => {
        var getzines = data.data.data;
        this.getzines = getzines;
      })

    },
    timeDiff(published) {
      var now = new Date();
      var date3 = now.getTime() - published;

      // 计算相差年数
      var years = Math.floor(date3 / (356 * 24 * 3600 * 1000))
      //计算出相差天数
      var days = Math.floor(date3 / (24 * 3600 * 1000))
      //计算出小时数
      var hours = Math.floor(date3 / (3600 * 1000))
      //计算相差分钟数
      var minutes = Math.floor(date3 / (60 * 1000))
      // 计算相差秒数
      var seconds = Math.floor(date3 / 1000)

      if (years > 0) {
        var time = new Date(published);
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        return y + '-' + m + '-' + d;
      }

      if (days > 0) {
        if (days > 7) {
          var time = new Date(published);
          var m = time.getMonth() + 1;
          var d = time.getDate();
          return m + '-' + d;
        } else {
          if (days === 1) {
            return days + 'day ago';
          }
          return days + 'days ago';
        }
      }

      if (hours > 0) {
        if (hours === 1) {
          return hours + 'hour ago';
        }
        return hours + 'hours ago';
      }

      if (minutes > 0) {
        if (minutes === 1) {
          return minutes + 'minute ago';
        }
        return minutes + 'minutes ago';
      }
      if (seconds > 0) {
        if (seconds === 1) {
          return seconds + 'second ago';
        }
        return seconds + 'second ago';
      }
    },
    subContentId(contentId) {
      // 查找 站点是否存在
      var start = contentId.indexOf('_');

      if (start > 0) {
        var arr = contentId.split('_');
        return arr[1];
      } else {
        return contentId;
      }
    },
    subImage(thumb) {
      // 处理组图的显示
      var start = thumb.indexOf('|');

      if (start > 0) {
        var arr = thumb.split('|');
        return arr[1];
      } else {
        return thumb;
      }
    },
    // 获取自贸区新闻资讯
    getFtzNew(page){
      if (page == undefined) {
        page = 1
      }
      this.loading = true;
      let par = {
        token:"",
        num: 0
      }
      if (this.newrecoToken && page != 1) {
        par.num = (page-1)
        par.token = this.newrecoToken
      }
      // if (page == 1){
      //   if (localStorage.getItem('newValueDetail')) {
      //       var list2 = JSON.parse(localStorage.getItem('newitemDetailValueList'));
      //       this.itemDetailValue = list2;
      //       this.loading = false;
      //       return
      //   }
      // }

      var removeLastPart = function(url) {
          var lastSlashIndex = url.lastIndexOf("/");
          if (lastSlashIndex > url.indexOf("/") + 1) { // if not in http://
              return url.substr(0, lastSlashIndex); // cut it off
          } else {
              return url;
          }
      }
      
      // cnfrecommend(par)
      // this.$pdAxios({
      //   method: 'get',
      //   url: '/recommend/rest/2/0/'+par.num+'/Financial%20Str.%20Release',
      //   baseURL: removeLastPart(baseUrl),
      //   data: {'token':par.token},
      // })
      // this.$axios.get(`${ftaBaseUrl.base_2}/recommend/rest/2/0/${par.num}/Financial%20Str.%20Release`, 
      //   {'token':par.token}
      // )
      
      // request("get", `${baseUrl.base_2}/recommend/rest/2/0/${par.num}/Financial%20Str.%20Release`, {
      //   token: par.token,
      // })

      // @GetMapping("/{language}/{type}/{pageNo}/{sortType}/{model}/{startTime}/{endTime}/{kw}")
      this.$axios({
        url: `https://recommend.imsilkroad.com/recommend/rest/2/0/${par.num}/1/0/0/0/Financial%20Str.%20Release?token=${par.token}`,
        method: 'get'
      })
      .then(res2 => {
        let res = res2.data;
          if (res.code == 500) {
            localStorage.removeItem("newrecoToken")
            localStorage.removeItem("newValueDetail")
            localStorage.removeItem("newitemDetailValueList")
            localStorage.removeItem("newresultValueList")
            localStorage.removeItem("newselectValueList")
            this.getFtzNew(1)
            return;
          }
          this.newrecoToken = res.token
          localStorage.setItem("newrecoToken",res.token);
          const data = res.results;
          this.itemDetailValue.page = page;
          this.itemDetailValue.spaceLoadShow = false;
          this.itemDetailValue.size = 10;
          this.itemDetailValue.total = res.totalPage;
          this.itemDetailValue.pageCount = _.ceil(res.totalPage / 20);
          data.map(el => el.id = el.resourceId.split('_')[1] || el.id);
          let arr = []
          data.map(ele=>{
            arr.push({sourceAsMap: ele})
          })
          // this.itemDetailValue.content = arr;
          this.loading = false;
          if (page > 0) {
            this.itemDetailValue.content = _.concat(this.itemDetailValue.content, arr)
          } else {
            this.itemDetailValue.content = arr
          }
          if (page == 1) {
            this.itemDetailValue.content = arr
            localStorage.setItem('newselectValueList', JSON.stringify(this.selectValue));//重点在这里
            localStorage.setItem('newresultValueList', JSON.stringify(this.resultValue));//重点在这里
            localStorage.setItem('newitemDetailValueList', JSON.stringify(this.itemDetailValue));//重点在这里
            localStorage.setItem("newValueDetail",true)
          }
          return
        })
        .catch(err => {
            this.loading = false
            if (this.itemDetailValue) {
              this.itemDetailValue.total = 0
              this.itemDetailValue.pageCount = 0
              this.itemDetailValue.content = []
              this.itemDetailValue.spaceLoadShow = false
              this.selectValue = []
            }
        });
    },
    requestAllData(page, code) {
      if (page == undefined) {
        page = 1
      }
      page === 1 && (this.loading = true)
      this.itemDetailValue.page = page
      let filters = _.cloneDeep(this.filters)
      let option = {}
      this.itemDetailValue.spaceLoadShow = true
      let allType = _.cloneDeep(searchMap.allSearchType)
      let aggs = searchMap.searchAggs
      if (this.selectType !== 'All') {
        let ite = _.find(searchMap.typeAgg, ['key', this.selectType])
        allType = [ite.id]
        ite.filter && filters.push(ite.filter)
        option = ite.option || {}
      }
      const arr = searchMap.searchList[this.selectType]
      aggs = _.filter(aggs, (item) => {
        return _.indexOf(arr, item.k.name) !== -1
      })
      if (this.$route.query.advanced === 'true') {
        // allType = [this.$route.query.select]
        let hightArr = JSON.parse(localStorage.getItem('advanceQuery'))
        hightArr = _.filter(hightArr, (item) => {
          if (item.column === 'published') {
            if (item.value) {
              let _filter = {
                d: '1',
                k: 'published',
                v: item.value
              }
              let index = _.findIndex(this.filters, (o) => o.k === _filter.k)
              if (index !== -1) {
                filters.splice(index, 1, _filter)
              } else {
                filters.push(_filter)
              }
            }
            return false
          }
          return item.column
        })
        _.forEach(hightArr, (item) => {
          if (item.column !== 'published') {
            if (item.type === 1 && item.column.indexOf('.smart') !== -1) {
              item.column = item.column.replace('.smart', '.keyword')
            }
            item.column = JSON.stringify([item.column])
          }
        })
        this.hightQueryBean = hightArr
      }
      let data = {
        docTypeList: allType,
        kw: this.keyWord,
        featureWeights: [],
        filters: filters,
        hieghtQueryBean: this.hightQueryBean,
        isExplain: false,
        pageNo: this.itemDetailValue.page,
        pageSize: this.itemDetailValue.size,
        templateId: '3',
        current: 0,
        isAggs: 1,
        aggs: aggs,
        isRecovery: Boolean(this.isRecovery),
        psn: 10005,
        ...option
      }
      if (this.searchToken && this.itemDetailValue.page != 1){
        data.token = this.searchToken?this.searchToken:''
      }
      data.isFilter = 0
      if (this.sortField === 'published') {
        data.sortField = this.sortField
        data.sorts = '1'  // 排序方式 0 升序 1 降序
      }
      if (this.sortField === '混合排序') {
        data.featureWeights = [
          { 'k': '16', 'v': '2' },
          { 'k': '19', 'v': '1' },
          { 'k': '18', 'v': '1.3' },
          { 'k': '17', 'v': '1.5' },
          { 'k': '20', 'v': '2' }
        ]
        data.templateId = '3'
      }
      // if (page == 1){
      //   if (localStorage.getItem('selectValueDetail')) {
      //     var list = JSON.parse(localStorage.getItem('selectValueList'));
      //     this.selectValue = list;
      //     var list1 = JSON.parse(localStorage.getItem('resultValueList'));
      //     this.resultValue = list1;
      //     var list2 = JSON.parse(localStorage.getItem('itemDetailValueList'));
      //     this.itemDetailValue = list2;
      //     this.loading = false;
      //     if (list2.page >= this.itemDetailValue.page){
      //       return
      //     }
      //   }
      // }
      
      // cnfsimplekw(data)
      // this.$axios.post(`/kgapi/search/simplekw`,data)
      this.$pdAxios({
        method: 'post',
        url: '/search/simplekw',
        baseURL: baseUrl,
        data: data,
      })
      .then((res) => {
        let data = res.data;
          if (data.errCode === 200) {
            if (data.data.errCode === 500) {
              localStorage.removeItem("simpltoken")
              localStorage.removeItem("selectValueList")
              localStorage.removeItem("resultValueList")
              localStorage.removeItem("itemDetailValueList")
              localStorage.removeItem("selectValueDetail")
              this.requestAllData(1);
              return
            } 
            this.searchToken = data.data.token
            localStorage.setItem("simpltoken",data.data.token)
              // if (!type) {
              _.forEach(data.data.tAggregationItem, (item) => {
                item.isShow = false
              })
              for (let item of data.data.tAggregationItem) {
                if (item && item.k && item.k.name === '时间') {
                  item.v = _.reverse(_.sortBy(item.v, ['key']))
                  for (let _item of item.v) {
                    // _item.value = this.timeTampToTime(_item.value)
                  }
                }
                if (item && item.k.name) {
                  item.k._name = searchMap.chinaToEnglish[item.k.name]
                }
              }
              this.selectValue = data.data.tAggregationItem
              // }
              this.hightQueryBean = []
              this.resultValue.keyWord = data.data.kw
              this.resultValue.result = data.data.recovery
              this.resultValue.rsCount = data.data.rsCount
              this.itemDetailValue.total = data.data.searchTime.total
              this.itemDetailValue.pageCount = _.ceil(this.itemDetailValue.total / this.itemDetailValue.size)
              if (this.itemDetailValue.page > 1) {
                this.itemDetailValue.content = _.concat(this.itemDetailValue.content, data.data.rsData)
              } else {
                this.itemDetailValue.content = data.data.rsData
              }
              if (this.itemDetailValue.page == 1) {
                this.itemDetailValue.content = data.data.rsData
                localStorage.setItem('selectValueList', JSON.stringify(this.selectValue));//重点在这里
                localStorage.setItem('resultValueList', JSON.stringify(this.resultValue));//重点在这里
                localStorage.setItem('itemDetailValueList', JSON.stringify(this.itemDetailValue));//重点在这里
                localStorage.setItem("selectValueDetail",true)
              }
            } else {
              this.resultValue.keyWord = ''
              this.resultValue.result = ''
              this.resultValue.rsCount = 0
              this.itemDetailValue.total = 0
              this.itemDetailValue.pageCount = 0
              this.itemDetailValue.content = []
              this.selectValue = []
            }
            this.itemDetailValue.spaceLoadShow = false
            this.loading = false
        })
        .catch(() => {
            if (page === 1) {
              this.loading = false
              this.resultValue.keyWord = ''
              this.resultValue.result = ''
              this.resultValue.rsCount = 0
              this.itemDetailValue.total = 0
              this.itemDetailValue.pageCount = 0
              this.itemDetailValue.content = []
              this.itemDetailValue.spaceLoadShow = false
              this.selectValue = []
            }
          })


      // cnfsimplekw(data)
      //     .then((data) => {
      //       if (data.errCode === 200) {
      //         this.searchToken = data.data.token
      //         // if (!type) {
      //         _.forEach(data.data.tAggregationItem, (item) => {
      //           item.isShow = false
      //         })
      //         for (let item of data.data.tAggregationItem) {
      //           if (item && item.k && item.k.name === '时间') {
      //             item.v = _.reverse(_.sortBy(item.v, ['key']))
      //             for (let _item of item.v) {
      //               // _item.value = this.timeTampToTime(_item.value)
      //             }
      //           }
      //           if (item && item.k.name) {
      //             item.k._name = searchMap.chinaToEnglish[item.k.name]
      //           }
      //         }
      //         this.selectValue = data.data.tAggregationItem
      //         // }
      //         this.hightQueryBean = []
      //         this.resultValue.keyWord = data.data.kw
      //         this.resultValue.result = data.data.recovery
      //         this.resultValue.rsCount = data.data.rsCount
      //         this.itemDetailValue.total = data.data.rsCount
      //         this.itemDetailValue.pageCount = _.ceil(this.itemDetailValue.total / this.itemDetailValue.size)
      //         if (this.itemDetailValue.page > 1) {
      //           this.itemDetailValue.content = _.concat(this.itemDetailValue.content, data.data.rsData)
      //         } else {
      //           this.itemDetailValue.content = data.data.rsData
      //         }
      //       } else if (data.message === 'token不合法') {
      //         this.itemDetailValue.page = this.itemDetailValue.page - 1
      //       } else {
      //         this.resultValue.keyWord = ''
      //         this.resultValue.result = ''
      //         this.resultValue.rsCount = 0
      //         this.itemDetailValue.total = 0
      //         this.itemDetailValue.pageCount = 0
      //         this.itemDetailValue.content = []
      //         this.selectValue = []
      //       }
      //       this.itemDetailValue.spaceLoadShow = false
      //       this.loading = false
      //     })
      //     .catch(() => {
      //       if (page === 1) {
      //         this.loading = false
      //         this.resultValue.keyWord = ''
      //         this.resultValue.result = ''
      //         this.resultValue.rsCount = 0
      //         this.itemDetailValue.total = 0
      //         this.itemDetailValue.pageCount = 0
      //         this.itemDetailValue.content = []
      //         this.itemDetailValue.spaceLoadShow = false
      //         this.selectValue = []
      //       }
      //     })
    },
  },
  computed: {
    isFollow() {
      return this.$store.state.screenWidth;
    }
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        var self = this;
        let that = this;

      },
      deep: true
    },
    '$route.params': {
      handler() {
        // debugger
        this.selectType = this.$route.params.type || 'All'
        this.keyWord = this.$route.params.keyword || 'Financial Str. Release'
        this.$refs.searchResult.selectType = '混合排序'
        this.sortField = '混合排序'
        this.graphValue.graph = null
        this.clearSelectItem()
        if (this.routeSearchTime) {
          clearTimeout(this.routeSearchTime)
        }
        // this.requestAllData()
        this.getFtzNew(1)
        this.searchChart()
        this.$nextTick(() => {
          this.requestConcept().then(() => {
            // this.updateEcharts()
          })
        })
      },
      deep: true
    },
    isFollow(val) {
      if (!this.timer) {
        //this.screenWidths = val;
        this.timer = true;
        let that = this;
        setTimeout(function() {
          if (that.IsPC() && (val <= 1400)) {
            that.specail = true
          } else {
            that.specail = false
          }
          that.timer = false
        }, 10000)
      }

    }
  }
})
</script>
<style>
.col-md-99 {
  max-width: 98%;
}
.inner-container {
  height: 90vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.inner-container::-webkit-scrollbar {
  display: none;
}
.tabs-container .el-tabs__header {
  margin: 5px 0 5px;
}
.tabs-container .el-tabs--card>.el-tabs__header .el-tabs__item .el-icon-close {
  font-size: 18px;
  width: 18px;
}
.tabs-container .el-tabs--card>.el-tabs__header .el-tabs__item.is-active.is-closable .el-icon-close,.tabs-container  .el-tabs--card>.el-tabs__header .el-tabs__item.is-closable:hover .el-icon-close{
  width: 18px;
}
.tabs-container .el-icon-close::before{
  content: "\e6ce";
}
.title {
  font-size: 16px;
  line-height: 2;
  color: rgb(64, 156, 249);
  margin: 4px 0 10px 0;
  padding-left: 10px;
  font-weight: 500;
  position: relative;
  border-bottom: 1px solid #dedede;
}
.title:after{
  content: '';
  width: 50px;
  height: 1px;
  position: absolute;
  bottom: 0;
  left: 30px;
  display: block;
  background-color: rgb(64, 156, 249);
}
.scroll-wrap{
  overflow: hidden;
  position: relative;
  padding-left: 60px;
  /* // width: 100%; */
  margin-left: 10px;
}
.scroll-wrap:before {
  content: 'Roll';
  height: 40px;
  width: 76px;
  display: block;
  border-radius: 5px;
  background: url('./components/ArticleDetails/images/roll-bg.png') 100% 100%;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;
}
.scroll-text{
  height: 40px;
  background: #fff;
  margin-left: 10px;
  list-style: disc;
  width: 10000px;
}
.scroll-text .scroll-li {
  font-size: 14px;
  line-height: 40px;
  font-weight: 500;
  float: left;
  margin: 0 20px;
  width: auto;
  cursor: pointer;
}
.scroll-shadow {
  height: 40px;
  background: #fff;
  margin-left: 10px;
  white-space: nowrap;
  width: auto;
  display: inline-block;
  zoom: 1;
}
.scroll-shadow .scroll-li {
  display: inline-block;
  font-size: 14px;
  line-height: 40px;
  font-weight: 500;
  margin: 0 20px;
}
/* // margin: 10px 0 10px 10px; */
.tabs-container .el-tabs__item {
  width: 50% !important;
  text-align: center;
  background: url("./components/ArticleDetails/images/tab-bg.png");
  background-size: 102% 100%;
  background-position: -3px;
  background-repeat: no-repeat;
  padding-right: 50px;
  color:#fff !important;
  
}
.tabs-container.is-active{
  background: url("./components/ArticleDetails/images/tab-bg-active.png");
  background-size: 102% 100%;
  background-position: -3px;
  background-repeat: no-repeat;
  border-color: #fc9a51;
  color:#fff !important;
}
.el-tabs__nav {
  width: 100% !important;
  border: none!important;
  margin-left: 10px!important;
}
.quote-graph-container .quote-graph-component {
  height: 19vh;
}
.report-container {
  padding-left: 10px;
}
.report-item {
  width: 32%;
  background-color: #fff;
  padding: 10px;
  text-align: center;
  
}
.report-item .repo-title {
  font-size: 16px;
  line-height: 2;
  display: flex;
  font-weight: 500;
  padding: 0 10px;
  vertical-align: middle;
  
}
.report-item .repo-title .overflow-hidden-1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 30px);
  margin-right: 10px;
}
.report-item .repo-title .link-out {
  width: 20px;
  height: 20px;
  background: url("./components/ArticleDetails/images/export-icon.png") center center no-repeat;
  background-size: 60% 60%;
  margin-top: 5px;
} 
.report-item .repo-img {
  width: 215px;
  height: calc(100% - 32px);
  text-align: center;
  display: inline-block;
  padding: 5px;
  border: 1px solid #e6e9ec;
}
.report-item .repo-img img {
  width: auto;
  max-width: 100%;
  height: 100%;
}
.back-button {
  font-weight: bold;
  font-size: 16px;
  line-height: 2;
  cursor: pointer;
  
}
.back-button:hover {
  color: #00A1E9;
}

.nano > .nano-contents {
  position: relative;
  max-height: 440px;
  margin: auto !important;
}
#home_right_list.cur {
  position: absolute;
  overflow: scroll;
  overflow-x: hidden;
  bottom: 0;
  height: inherit;
}
.centre_sm_none .el-tabs__nav .is-active {
  font-size: 18px;
}
</style>
